import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
//import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext";
import { AccountProvider } from "./context/AccountContext";
import App from './App';

// Vite provides import.meta.env.BASE_URL for the app base path.
const baseUrl = import.meta.env.BASE_URL;
const root = createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();

root.render((
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <AccountProvider>
                <BrowserRouter basename={baseUrl}>
                    <App />
                </BrowserRouter>
            </AccountProvider>
        </AuthProvider>
    </QueryClientProvider>
) as React.ReactElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
